import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  // Phase 9.3: replaced animate-pulse with shell-shimmer for elegant scanning
  // motion across all already-disciplined skeleton surfaces (Earnings, Calendar,
  // Leaderboard, News, etc.). Honors prefers-reduced-motion via the utility.
  return <div className={cn("shell-shimmer rounded-md", className)} {...props} />;
}

export { Skeleton };
